module.exports = __webpack_public_path__ + "img/EP18Menu2_active.640b804b.png";